// src/Components/Modules/CompanySetting/ExchangeRates.js
import React, { useState, useEffect } from 'react';
import { AxiosAuthInstance } from '../../../AxiosInterceptors';
import Breadcrumb from '../../Partials/Breadcrumb';
import { Box, Typography, Paper, Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, DialogTitle, DialogContent, DialogActions, Chip, IconButton } from '@mui/material';
import { FaPlus, FaEdit, FaSave } from 'react-icons/fa';
import Swal from 'sweetalert2';

export default function ExchangeRates() {
    const [rates, setRates] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [editing, setEditing] = useState(null);
    const [form, setForm] = useState({ currency_code: '', exchange_rate: '' });

    const fetchData = async () => {
        const res = await AxiosAuthInstance.get('exchange-rates');
        setRates(res.data.rates || []);
    };
    useEffect(() => { fetchData(); }, []);

    const handleSave = async () => {
        try {
            const url = editing ? `exchange-rates/${editing.id}` : 'exchange-rates';
            const method = editing ? 'put' : 'post';
            await AxiosAuthInstance[method](url, form);
            Swal.fire({ icon: 'success', title: 'Saved!', timer: 1500, showConfirmButton: false });
            setDialogOpen(false);
            fetchData();
        } catch (err) { Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Failed' }); }
    };

    return (
        <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
            <Breadcrumb title="Exchange Rates" />
            <Paper sx={{ p: 3, mb: 3, display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h5" fontWeight={700}>Multi-Currency Exchange Rates</Typography>
                <Button variant="contained" startIcon={<FaPlus />} onClick={() => { setEditing(null); setForm({ currency_code: '', exchange_rate: '' }); setDialogOpen(true); }}>Add Currency</Button>
            </Paper>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead><TableRow sx={{ bgcolor: '#f8f9fa' }}><TableCell>Currency Code</TableCell><TableCell>Exchange Rate (to Base)</TableCell><TableCell align="center">Actions</TableCell></TableRow></TableHead>
                    <TableBody>
                        {rates.map((r) => (
                            <TableRow key={r.id} hover>
                                <TableCell><Chip label={r.currency_code} color="primary" /></TableCell>
                                <TableCell>{Number(r.exchange_rate).toFixed(4)}</TableCell>
                                <TableCell align="center">
                                    <IconButton size="small" onClick={() => { setEditing(r); setForm({ currency_code: r.currency_code, exchange_rate: r.exchange_rate }); setDialogOpen(true); }}><FaEdit /></IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>{editing ? 'Update Rate' : 'Add Currency'}</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField label="Currency Code (e.g., USD)" value={form.currency_code} onChange={(e) => setForm({...form, currency_code: e.target.value.toUpperCase()})} disabled={!!editing} fullWidth />
                        <TextField label="Exchange Rate" type="number" value={form.exchange_rate} onChange={(e) => setForm({...form, exchange_rate: e.target.value})} fullWidth />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
                    <Button variant="contained" startIcon={<FaSave />} onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}